import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { StylesType } from '@/types';
import { vMaska } from 'maska';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasePhoneInput',
  props: /*#__PURE__*/_mergeModels({
    modelValue: { default: undefined },
    disabled: { type: Boolean },
    label: {},
    labelInValue: { type: Boolean, default: false },
    height: { default: '36' },
    styles: {},
    styleType: { default: undefined },
    required: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(['update:modelValue', 'focus'], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
// eslint-disable-next-line no-undef
const inputValue = _useModel<string | number | undefined>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!

  return _withDirectives((_openBlock(), _createBlock(_component_base_input, {
    disabled: _ctx.disabled,
    height: _ctx.height,
    label: _ctx.label,
    labelInValue: _ctx.labelInValue,
    required: _ctx.required,
    styleType: _ctx.styleType,
    styles: _ctx.styles,
    "v-model": inputValue.value,
    "data-maska": "(###)###-##-##",
    placeholder: "+7 (999)000-99-99"
  }, null, 8, ["disabled", "height", "label", "labelInValue", "required", "styleType", "styles", "v-model"])), [
    [_unref(vMaska)]
  ])
}
}

})